let store = require("../store");
let actions = require("../actions");

let DesignTabs = require("../widget/DesignTabs");
let LifecycleStateFlag = require("../widget/LifecycleStateFlag");
let StudyActivities = require("../widget/StudyActivities");
let StudyDeviceConfigs = require("../widget/StudyDeviceConfigs");
let StudyDiaries = require("../widget/StudyDiaries");

let ActivityFormView = require("./ActivityFormView");
let CustomFieldsFormView = require("./CustomFieldsFormView");
let DiaryFormView = require("./DiaryFormView");
let ProgramView = require("./ProgramView");
let StudyFormView = require("../view/StudyFormView");
let LifecyclePromptView = require("../view/LifecyclePromptView");

let IconButton = mc.widgets.IconButton;
let Toggle = mc.widgets.Toggle;

class DesignView extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.getInitialState();
  }

  getInitialState() {
    let state = store.getState();

    return {
      study: state.study[this.props.studyId],
      prefs: state.prefs,
      editMode: null
    };
  }

  componentDidMount() {
    this.unsubscribe = store.subscribe(this.handleStoreChange.bind(this));

    actions.loadStudy(this.props.studyId);
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.studyId !== this.props.studyId) {
      actions.loadStudy(this.props.studyId);
    }
  }

  handleStoreChange() {
    this.setState(this.getInitialState());
  }

  editActivities() {
    this.setState({
      editMode: "activities"
    });
  }

  editDiaries() {
    this.setState({
      editMode: "diaries"
    });
  }

  editStudy() {
    StudyFormView.open(this.state.study);
  }

  editSubjectFields() {
    CustomFieldsFormView.open(this.state.study);
  }

  loadStudy() {
    rc.actions.loadStudy(this.props.studyId);
  }

  saveActivitySequence(activities) {
    actions.saveActivitySequence(activities).then(() => {
      this.loadStudy();
    });
  }

  saveDiarySequence(diaries) {
    actions.saveDiarySequence(diaries).then(() => {
      this.loadStudy();
    });
  }

  copyActivity(activity) {
    this.copy(activity, tx("copy_activity"), actions.copyActivity, () => {
      this.loadStudy();
    });
  }

  copyDiary(diary) {
    this.copy(diary, tx("copy_diary"), actions.copyDiary, () => {
      this.loadStudy();
    });
  }

  copyStudy() {
    this.copy(this.state.study, tx("copy_study"), actions.copyStudy, (payload) => {
      mc.router.refresh({ studyId: payload.study.id });
      actions.loadStudies(store.getState().accountId);
    });
  }

  copy(obj, message, action, callback) {
    this.setState({
      editMode: "copy"
    });

    mc.ui.alert(message, {
      mode: "confirm",
      labels: {
        confirm: tx("copy"),
        cancel: tx("cancel")
      },
      input: "Copy of " + obj.displayName,
      onHide: (function (confirmed, input) {
        let copy = mc.utils.clone(obj);

        if (confirmed) {
          copy.displayName = input;

          action(copy).then(function (payload) {
            if (payload.errors.length) {
              mc.ui.alert(payload.errors[0], { level: "error" });
              return;
            }

            callback(payload);
          });
        }
        else {
          this.setState({
            editMode: null
          });
        }
      }).bind(this)
    });
  }

  cancel() {
    this.setState({
      editMode: null
    });
  }

  startStudy() {
    let { study } = this.state;

    LifecyclePromptView.open(study, "start");
  }

  stopStudy() {
    let { study } = this.state;

    LifecyclePromptView.open(study, "stop");
  }

  createDeviceConfig() {
    mc.router.trigger("NEW_DEVICE_VIEW", { studyId: this.props.studyId });
  }

  createActivity() {
    let activity = {
      displayName: "",
      durationSec: 0,
      instructions: "",
      order: ~~(Date.now() / 1000) - 1420088400,
      questions: [],
      studyId: this.props.studyId,
      mode: this.state.prefs.designSupervisionMode || "SUPERVISED"
    };

    ActivityFormView.open(activity, false);
  }

  createDiary() {
    let diary = {
      displayName: "",
      order: ~~(Date.now() / 1000) - 1420088400,
      questions: [],
      studyId: this.props.studyId,
      mode: this.state.prefs.designSupervisionMode || "SUPERVISED"
    };

    DiaryFormView.open(diary, false);
  }

  setSupervisionMode(mode) {
    actions.setPref("designSupervisionMode", mode);
  }

  enableAnalytics(pressed) {
    let action;
    let studyId = this.props.studyId;
    let libConfigId = "fdd051b8-d753-11e6-ab51-34363bc84032";

    this.setState({
      editMode: "analytics"
    });

    if (pressed) {
      action = rc.actions.addPipeline(studyId, libConfigId);
    }
    else {
      action = rc.actions.removePipeline(studyId, this.state.study.pipelines[0].id);
    }

    action.then(() => {
      this.loadStudy();

      this.setState({
        editMode: null
      });
    });
  }

  initProgram(studyId) {
    return {
      parentEntityId: studyId,
      scheduleType: "SIMPLE",
      schedules: [{
        displayName: "Phase A",
        mode: "ORDINAL",
        durationDays: 30,
        columns: [{
          wearSensors: true,
          rows: []
        }]
      }]
    };
  }

  render() {
    let study = this.state.study || {};
    let supervisionMode = this.state.prefs.designSupervisionMode || "SUPERVISED";
    let deviceConfigs = study.deviceConfigs || [];
    let activities = study.activities || [];
    let customFields = study.subjectMetadataFields || [];
    let diaries = study.diaries || [];
    let program = study.id ? (study.program || this.initProgram(study.id)) : null;
    let analyticsEnabled = study.pipelines && study.pipelines.length > 0;
    let locked = !this.state.study || /IN_PROGRESS|COMPLETE/.test(study.lifecycleState);
    let editing = this.state.editMode !== null;

    return (
      <div className="rc-design-view" data-study-id={study.id} data-study-name={study.displayName}>
        <div className="mc-split-layout">
          <div>
            <h1>
              {study.displayName || "..."}
              <LifecycleStateFlag lifecycleState={study.lifecycleState}/>
            </h1>
            <p>{study.title || "..."}</p>
          </div>
          <div>
            {study.id ? (
              <div className="rc-control-strip">
                <IconButton
                  id="copy_study_button"
                  icon="copy"
                  label={tx("copy")}
                  disabled={!study.id || editing}
                  onPress={this.copyStudy.bind(this)}/>
                <IconButton
                  id="edit_study_button"
                  icon="edit"
                  label={tx("edit")}
                  disabled={!study.id || editing}
                  onPress={this.editStudy.bind(this)}/>

                {study.lifecycleState === "INITIALIZED" ? (
                  <IconButton
                    id="start_study_button"
                    icon="./img/rc/icon.start.svg"
                    label={tx("study_intent.start")}
                    disabled={(study.deviceConfigs || []).length === 0}
                    scale={1.5}
                    onPress={this.startStudy.bind(this)}/>
                ) : null}

                {study.lifecycleState === "IN_PROGRESS" ? (
                  <IconButton
                    id="stop_study_button"
                    icon="./img/rc/icon.stop.svg"
                    label={tx("study_intent.stop")}
                    scale={1.5}
                    onPress={this.stopStudy.bind(this)}/>
                ) : null}
              </div>
            ) : null}
          </div>
        </div>

        <div className="rc-design-view-sidebar">
          <DesignTabs
            selected={supervisionMode}
            onSelect={this.setSupervisionMode.bind(this)}/>
        </div>

        <div className="rc-design-view-content mc-sidebar-layout">
          <div>
            <h2>{tx("sensors." + supervisionMode)}</h2>
            <div className="mc-card" id="rc-design-view-device-configs">
              <div className="rc-control-strip">
                {supervisionMode === "UNSUPERVISED" ? (
                  <IconButton
                    icon="help"
                    onPress={() => mc.ui.help(`./help/${rc.lang}/body_locations.html`)}/>
                ) : null}
                <IconButton
                  id="new_sensor_button"
                  icon="plus"
                  label={tx("new_sensor")}
                  disabled={locked || editing}
                  onPress={this.createDeviceConfig.bind(this)}/>
              </div>
              <StudyDeviceConfigs
                configs={deviceConfigs.filter((d) => d.mode === supervisionMode)}
                locked={locked}/>
            </div>

            <h2>{tx("activities." + supervisionMode)}</h2>
            <div className="mc-card" id="rc-design-view-activities">
              <div className="rc-control-strip">
                {supervisionMode === "SUPERVISED" ? (
                  <IconButton
                    id="order_activities_button"
                    icon="reorder"
                    label={tx("reorder")}
                    disabled={locked || editing || activities.filter((a) => a.mode === "SUPERVISED").length < 2}
                    onPress={this.editActivities.bind(this)}/>
                ) : null}
                <IconButton
                  id="new_activity_button"
                  icon="plus"
                  label={tx("new_activity")}
                  disabled={locked || editing}
                  onPress={this.createActivity.bind(this)}/>
              </div>
              <StudyActivities
                editing={this.state.editMode === "activities"}
                disabled={locked || editing}
                activities={activities.filter((a) => a.mode === supervisionMode)}
                onCopy={this.copyActivity.bind(this)}
                onSave={this.saveActivitySequence.bind(this)}
                onCancel={this.cancel.bind(this)}/>
            </div>

            <h2>{tx("diaries." + supervisionMode)}</h2>
            <div className="mc-card" id="rc-design-view-diaries">
              <div className="rc-control-strip">
                {supervisionMode === "SUPERVISED" ? (
                  <IconButton
                    id="order_diaries_button"
                    icon="reorder"
                    label={tx("reorder")}
                    disabled={locked || editing || diaries.filter((d) => d.mode === "SUPERVISED").length < 2}
                    onPress={this.editDiaries.bind(this)}/>
                ) : null}
                <IconButton
                  id="new_diary_button"
                  icon="plus"
                  label={tx("new_diary")}
                  disabled={locked || editing}
                  onPress={this.createDiary.bind(this)}/>
              </div>
              <StudyDiaries
                editing={this.state.editMode === "diaries"}
                disabled={locked || editing}
                diaries={diaries.filter((d) => d.mode === supervisionMode)}
                onCopy={this.copyDiary.bind(this)}
                onSave={this.saveDiarySequence.bind(this)}
                onCancel={this.cancel.bind(this)}/>
            </div>

            {supervisionMode === "UNSUPERVISED" ? (
              <div>
                <h2>{tx("program")}</h2>
                <div className="mc-card" id="rc-design-view-program">
                  <ProgramView
                    program={program}
                    studyId={study.id}
                    activities={activities.filter((a) => a.mode === "UNSUPERVISED")}
                    diaries={diaries.filter((d) => d.mode === "UNSUPERVISED")}
                    disabled={locked || editing}/>
                </div>
              </div>
            ) : null}
          </div>
          <div>
            <section>
              <div className="mc-split-layout">
                <h2>{tx("subject_fields")}</h2>
                <IconButton
                  id="edit_custom_fields_button"
                  icon="edit"
                  scale={0.8}
                  label={tx("edit")}
                  disabled={locked || editing}
                  onPress={this.editSubjectFields.bind(this)}/>
              </div>
              {customFields.length ? (
                <ul className="rc-design-view-subject-fields">
                  {customFields.map(function (field) {
                    return <li key={field.displayName}>{field.displayName}</li>;
                  })}
                </ul>
              ) : <p>{tx("none")}</p>}
            </section>
            {supervisionMode === "UNSUPERVISED" ? (
              <section>
                <h2>{tx("analytics")}</h2>
                <Toggle
                  id="analytics_button"
                  pressed={analyticsEnabled}
                  disabled={locked || editing}
                  onPress={this.enableAnalytics.bind(this)}/>
                <p>
                  <small>
                    <a onClick={() => mc.ui.help(`./help/${rc.lang}/analytics.html`)}>
                      {tx("learn_more")}
                    </a>
                  </small>
                </p>
              </section>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

module.exports = DesignView;
